import React from 'react'
import classes from './SingleComment.module.css'
import classesP from './singleCommentContentPopup.module.css'
import { renderTextWithLinksAndHtml } from '../../../utils/renderTextWithLinksAndHtml'
import { betkoInfoPopup } from '../../../utils/notifications'

const SingleCommentContentPopup = ({ item, url }) => {
  const copyLink = () => {
    let type = item.type
    if (type === 'vasi_predlozi') type = 'nasi_predlozi'

    const url = `${window.location.origin}/${type}/${item.post}?commentId=${item._id}`
    navigator.clipboard.writeText(url)
    betkoInfoPopup('Link komentara kopiran!')
  }

  return (
    <div className={classesP.wrapper}>
      <div className={`${classes.commentLinkToPost} ${classesP.header}`}>
        <button onClick={() => (window.location.href = url)}>
          <span>
            {item?.type?.toUpperCase().replace(/_/g, ' ')} - Pogledajte komentar
          </span>
          <img
            src='/icons/comments/commentsArrowUp.svg'
            alt='ostavi komentar'
          />
        </button>
      </div>

      <div className={classes.singleCommentInner}>
        <div className={classes.commentBody}>
          <div className={classes.commentContent}>
            <div
              dangerouslySetInnerHTML={renderTextWithLinksAndHtml(
                item?.comment
              )}
            />
          </div>

          {item.adminFootnote && (
            <div className={classes.commentContent}>
              <br />
              <div
                dangerouslySetInnerHTML={renderTextWithLinksAndHtml(
                  item.adminFootnote
                )}
              />
            </div>
          )}
        </div>
        <div
          className={classes.commentFeedback}
          style={{ justifyContent: 'right' }}
        >
          <div onClick={copyLink} className={classes.feedbackLink}>
            <img src='/icons/comments/link.svg' alt='link' />
          </div>
        </div>
      </div>
    </div>
  )
}

export default SingleCommentContentPopup
